<template>
  <div>
    <!-- Fake Checkbox to Display Menu Contents -->
    <input id="checkbox" type="checkbox" />

    <!-- Hamburger Menu -->
    <span></span>
    <span></span>
    <span></span>

    <nav>
      <router-link to="/"><div>Home</div></router-link>
      <router-link to="/biography"><div>Bio</div></router-link>
      <router-link to="/portfolio"><div>Portfolio</div></router-link>
      <router-link to="/meet"><div>Meet</div></router-link>
      <router-link to="/photos"><div>Photos</div></router-link>
      <router-link to="/contact"><div>Contact</div></router-link>
    </nav>
  </div>
</template>

<script>
export default {
  name: "mobileNavBar",
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      document.getElementsByTagName("input")[0].checked = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../assets/fonts.css");

div {
  display: block;
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 2;
  -webkit-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  input {
    display: block;
    width: 40px;
    height: 32px;
    position: absolute;
    top: -7px;
    left: -5px;
    cursor: pointer;
    opacity: 0;
    z-index: 3;
    -webkit-touch-callout: none;
    &:checked ~ {
      nav {
        transform: none;
        opacity: 1;
      }
      span {
        opacity: 1;
        transform: rotate(45deg) translate(-2px, -1px);
        background: #232323;
        &:nth-last-child(3) {
          opacity: 0;
          transform: rotate(0deg) scale(0.2, 0.2);
        }
        &:nth-last-child(2) {
          opacity: 1;
          transform: rotate(-45deg) translate(0, -1px);
        }
      }
    }
  }

  span {
    display: block;
    width: 33px;
    height: 4px;
    margin-bottom: 5px;
    position: relative;
    background: #cdcdcd;
    border-radius: 3px;
    z-index: 2;
    transform-origin: 4px 0px;
    transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1),
      background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1), opacity 0.55s ease;
    &:first-child {
      transform-origin: 0% 0%;
    }
    &:nth-last-child(2) {
      transform-origin: 0% 100%;
    }
  }

  nav {
    position: absolute;
    width: 100vw;
    margin: -100px auto 0 auto;
    padding: 50px;
    padding-top: 125px;
    right: -20px;
    background: #525252;
    -webkit-font-smoothing: antialiased;
    transform-origin: 0% 0%;
    transform: translate(100%, 0);
    transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1);
    z-index: 1;
    box-sizing: border-box;
    a {
      font-family: "Smudge Stick";
      font-weight: 500;
      color: #fff;
      text-transform: uppercase;
      padding: 0;
      margin: 0;
      text-decoration: none;
      letter-spacing: 2px;
      text-align: center;
      position: relative;
      display: block;
      width: 100vw;
      margin-left: -20px;

      &.router-link-exact-active.router-link-active {
        div {
          &::before {
            opacity: 1;
            width: 100%;
            background-color: #ff6600;
          }

          &::after {
            opacity: 1;
            left: 98%;
            color: #ff6600;
          }
        }
      }

      div {
        display: inline-block;
        position: relative;
        margin: 10px auto;
        font-size: 22px;
        transition: all 0.75s ease-in-out;

        &::before {
          content: "";
          position: absolute;
          bottom: -8.3px;
          width: 0;
          height: 4px;
          margin: 5px 0 0;
          transition: all 0.75s ease;
          opacity: 0;
          background-color: #fff;
          display: inline-block;
        }

        &::after {
          content: "\e801";
          font-family: "icons";
          font-size: 16px;
          color: #fff;
          position: absolute;
          bottom: -15px;
          left: 0;
          opacity: 0;
          transition: all 0.75s ease;
        }
      }

      &:hover {
        div {
          &::before {
            opacity: 1;
            width: 100%;
          }
          &::after {
            opacity: 1;
            left: 98%;
          }
        }
      }
    }
  }
}
</style>
